import { render, staticRenderFns } from "./EdlButton.vue?vue&type=template&id=64d1e205&scoped=true&"
import script from "./EdlButton.vue?vue&type=script&lang=js&"
export * from "./EdlButton.vue?vue&type=script&lang=js&"
import style0 from "./EdlButton.vue?vue&type=style&index=0&id=64d1e205&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d1e205",
  null
  
)

export default component.exports